'use client';
import React from 'react';

import { Breadcrumbs } from '../../../../components/breadcrumbs';
import { EditorialPageFullWidth } from '../../../../components/page-components/editorial-page-full-width/editorial-page-full-width';
import useGetMobileAppWebViewHeader from '../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingplacePageHomeMinified } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageEditorialFullWidth } from '@/lib/fragments/meetingPlacePageEditorialFullWidth';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageEditorialFullWidthProps {
  metaData: any;
  node_locale: string;
  contentfulMeetingPlacePageEditorialFullWidth: IMeetingPlacePageEditorialFullWidth | null;
  contentfulMeetingPlacePageHome: IMeetingplacePageHomeMinified | null;
}

const MeetingPlacePageEditorialFullWidth = ({
  metaData,
  node_locale,
  contentfulMeetingPlacePageEditorialFullWidth,
  contentfulMeetingPlacePageHome,
}: MeetingPlacePageEditorialFullWidthProps) => {
  const page = contentfulMeetingPlacePageEditorialFullWidth;
  const homepage = contentfulMeetingPlacePageHome;
  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={node_locale}
        pageTitle={page?.name ?? ''}
      />
      <main className="bg-background-primary-light lg:-ml-22 lg:bg-transparent lg:px-0">
        <Breadcrumbs
          breadcrumbs={[page?.name || '']}
          homeText={homepage?.breadcrumbHomeText || ''}
          cssClass={`lg:ml-22 lg:px-0 px-6 ${isWebView ? '!pt-8' : ''}`}
          node_locale={node_locale}
        />
        {page && (
          <EditorialPageFullWidth
            page={page}
            integrationId={homepage?.meetingPlace?.integrationId}
            node_locale={node_locale}
          />
        )}
      </main>
    </>
  );
};
export default MeetingPlacePageEditorialFullWidth;
